module.exports = __webpack_public_path__ + "static/media/services-2.afc22b7d.svg";